import React from 'react';
import { products } from '../../data/portfolioData';

const ArrowURIcon = () => (
  <svg viewBox="0 0 16 16" fill="none" width="12" height="12" aria-hidden="true">
    <path d="M5 11L11 5M11 5H6.5M11 5v4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const GithubIcon = () => (
  <svg viewBox="0 0 16 16" fill="currentColor" width="12" height="12" aria-hidden="true">
    <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.012 8.012 0 0016 8c0-4.42-3.58-8-8-8z" />
  </svg>
);

const LABEL_CONFIG = {
  live: { cls: 'label label-live', text: 'Live Product' },
  public: { cls: 'label label-public', text: 'Public Product' },
  experiment: { cls: 'label label-experiment', text: 'Product Experiment' },
  oss: { cls: 'label label-oss', text: 'Open Source' },
};

function ProductLabel({ kind }) {
  const c = LABEL_CONFIG[kind] || LABEL_CONFIG.live;
  return <span className={c.cls}>{c.text}</span>;
}

function ProductVisual({ screenshot, url, name }) {
  if (screenshot) {
    return (
      <div className="project-visual">
        <img src={screenshot} alt={`${name} preview`} className="project-screenshot" loading="lazy" />
      </div>
    );
  }
  return (
    <div className="project-visual">
      <div className="mockup-window">
        <div className="mockup-bar">
          <span className="mockup-dot" />
          <span className="mockup-dot" />
          <span className="mockup-dot" />
          <span className="mockup-url-text">{url}</span>
        </div>
        <div className="mockup-body">
          <div className="mockup-line" style={{ width: '65%' }} />
          <div className="mockup-line" style={{ width: '85%' }} />
          <div className="mockup-line" style={{ width: '50%' }} />
          <div className="mockup-spacer" />
          <div className="mockup-line" style={{ width: '75%' }} />
          <div className="mockup-line" style={{ width: '40%' }} />
          <div className="mockup-spacer" />
          <div className="mockup-line" style={{ width: '90%' }} />
        </div>
      </div>
    </div>
  );
}

export default function Products() {
  return (
    <section className="section" id="products">
      <div className="container">
        <div className="section-head reveal">
          <div>
            <div className="section-tag">Products I&apos;ve Built</div>
            <h2>Real products, shipped for real users.</h2>
          </div>
          <p className="section-desc">
            From SaaS tools to news platforms and law firm sites — built end-to-end and deployed to production.
          </p>
        </div>

        <div className="projects">
          {products.map((p, i) => {
            const reversed = i % 2 !== 0;
            return (
              <article key={p.name} className="project reveal">
                <div
                  className="project-grid"
                  style={reversed ? { gridTemplateColumns: '1fr 1.05fr', direction: 'rtl' } : undefined}
                >
                  <div className="project-body" style={{ direction: 'ltr' }}>
                    <div className="project-head">
                      <div className="project-labels">
                        {p.labels.map(l => <ProductLabel key={l} kind={l} />)}
                      </div>
                      <h3>{p.name}</h3>
                      <p className="project-tagline">{p.tagline}</p>
                    </div>

                    <div className="project-meta">
                      <div className="project-stack">
                        {p.stack.map(s => <span key={s} className="chip">{s}</span>)}
                      </div>
<div className="project-actions">
                        {p.links.map((l, j) => (
                          <a
                            key={j}
                            className="project-link"
                            href={l.href}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {l.kind === 'github' && <GithubIcon />}
                            {l.label}
                            {l.kind !== 'github' && <ArrowURIcon />}
                          </a>
                        ))}
                      </div>
                    </div>
                  </div>

                  <div style={{ direction: 'ltr' }}>
                    <ProductVisual screenshot={p.screenshot} url={p.url} name={p.name} />
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
